import React from 'react'
import {Navigate, Outlet } from 'react-router-dom'
import { getDecryptedData } from '../config/crypto'

function PrivateComponent() {
    const auth =getDecryptedData('user')
    return auth ? <Outlet/> : <Navigate to='/'/>
  
}

export default PrivateComponent